var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07376 29.1387C8.41225 29.6146 7.48975 29.1419 7.48975 28.3269L7.48975 8.33236C7.48975 5.93912 9.42985 3.99902 11.8231 3.99902L21.8209 3.99902C24.2142 3.99902 26.1543 5.93912 26.1543 8.33236L26.1543 28.3269C26.1543 29.1419 25.2318 29.6146 24.5702 29.1387L16.822 23.5641L9.07376 29.1387ZM24.1543 8.33236C24.1543 7.04369 23.1096 5.99902 21.8209 5.99902L11.8231 5.99902C10.5344 5.99902 9.48975 7.04369 9.48975 8.33236L9.48975 26.3755L16.238 21.5204C16.5869 21.2694 17.0571 21.2694 17.406 21.5204L24.1543 26.3755L24.1543 8.33236Z",
    fill: "#131542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/Bookmark.2f498d2f45ef49629d0a60894af99ac1.svg";
export { ForwardRef as ReactComponent };